module.exports = __webpack_public_path__ + "media/stylesheets/images/Hiroshi Yasushima-5f2e321a7c194d6e905529c7de023734.jpg";